import React, { MouseEvent, useState, useEffect, useCallback } from 'react';
import Modal from 'react-modal';
import './App.css';
import { fetchHotwashInjects } from './features/injectSlice'
import { fetchGames } from './features/player/gameSlice'
import { getHotwashStatus, updateHotwashSelection } from './features/hotwash/hotwashSlice'
import HotwashTurnTimeline from './components/hotwash/HotwashTurnTimeline'
import HotwashNodeTimeline from './components/hotwash/HotwashNodeTimeline'
import { useAppSelector, useAppDispatch } from './app/hooks'
import { Scenario, GameStatus, InjectInfo, Hotwash, NewHostSelection, HostSelection, SelectedOption } from './Classes1';
import { IScenario, IGameStatus, IInjectInfo, IHotwash, ISelectedOption } from './interfaces';
import HotwashHeader from './components/hotwash/HotwashHeader';
import { fetchScenarios, getAllScenarios } from './features/scenarioSlice'
import { startHotwash } from './features/player/gameSlice'
import Select, { components } from 'react-select'
import { ActionMeta } from 'react-select';

Modal.setAppElement('#root');

export type PlayerHomeProps = {
  intervalHandler: (command: string, gameId: string, inGame: boolean) => void
};

enum TurnUpdateType {
  INCREMENT, SET
}

const HotwashApp: React.FC<PlayerHomeProps> = ({ intervalHandler }) => {

  let [hotwashInjects, setHotwashInjects] = useState<any[]>([]);
  let [injectItem, setInjectItem] = useState<IInjectInfo>(new InjectInfo());
  let [selectedScenario, setSelectedScenario] = useState<IScenario>(new Scenario({}));
  let [currentGame, setCurrentGame] = useState<IGameStatus>(new GameStatus());
  let [showHotwashTurnTimeline, setShowHotwashTurnTimeline] = useState<string>('show');
  let [showHotwashNodeTimeline, setShowHotwashNodeTimeline] = useState<string>('hide');
  let [hotwashStatus, setHotwashStatus] = useState<IHotwash>(new Hotwash());
  let [isHost, setIsHost] = useState<boolean>(false);
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [modalAARCIsOpen, setModalAARCIsOpen] = useState<boolean>(false);
  const [newAARCValue, setNewAARCValue] = useState<string>('');
  let [zoomLevel, setZoomLevel] = useState<number>(4);
  let [lastUserClick, setLastUserClick] = useState<string>("");
  let [selectedOption, setSelectedOption] = useState<ISelectedOption | null>(new SelectedOption({label: '1', value: 1}));

  const user = useAppSelector((state) => state.auth.userId)

  const queryParameters = new URLSearchParams(window.location.search)
  const gameId = queryParameters.get("gameid")

  const dispatch: any = useAppDispatch();

  const CustomDropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src="img/chevron-down-grey.svg" className={`chevron-down-grey`} alt="arrow" />
      </components.DropdownIndicator>
    );
  };

  const dropdownStyles = {
    option: (provided: any, { isFocused, isSelected } : { isFocused: any, isSelected: any }) => ({
      ...provided,
      backgroundColor: isFocused ? "#0E1425" : "#0E1425",
      fontSize: 18
    }),
    singleValue: (provided: any, state: any) => ({
        ...provided,
        padding: 0,
        color: '#EFEFEF',
        backgroundColor: "#0E1425",
        width: 20,
        fontSize: 18
    }),
    container:  (provided: any, state: any) => ({
      ...provided,
      backgroundColor: "#0E1425",
      border: "none",
      borderBottom: "1px solid #383C4D",
      width: 20,
      height: 24,
      display: 'inline-block',
      top: '0',
      left: '-5px'
    }),
    control:  (provided: any, state: any) => ({
      ...provided,
      backgroundColor: "#0E1425",
      color: '#EFEFEF',
      borderRadius: 0,
      border: "none",
      boxShadow: 0,
      width: 20,
      height: 20,
      minHeight: 24
    }),
    placeholder:  (provided: any, state: any) => ({
      ...provided,
      color: '#EFEFEF',
      fontSize: 18
    }),
    dropdownIndicator:  (provided: any, state: any) => ({
        ...provided,
        position: 'relative',
        display: "block",
        padding: 0,
        marginLeft: '5px',
        top: '-2px',
        "&:hover": {
            color: '#EFEFEF'
        }
      }),
    clearIndicator:  (provided: any, state: any) => ({
        ...provided,
        position: 'relative',
        display: "block",
        padding: 0,
        marginLeft: '5px',
        top: '-2px',
        "&:hover": {
            color: '#EFEFEF'
        }
      }),
    indicatorSeparator:  (provided: any, state: any) => ({
      ...provided,
      display: "none"
    }),
    menu:  (provided: any, state: any) => ({
      ...provided,
      width: 40,
      color: '#EFEFEF',
      backgroundColor: "#ccc",
      top: 20,
      zIndex: 16001
    }),
    menuList:  (provided: any, state: any) => ({
      ...provided,
      color: '#EFEFEF',
      backgroundColor: "#ccc",
      paddingTop: 0,
      paddingBottom: 0,
      zIndex: 20000,
      maxHeight: 600
    }),
    indicatorsContainer:  (provided: any, state: any) => ({
        ...provided,
        height: 20,
        display: 'block',
        position: 'relative',
        top: '-4px',
        left: '2px'
      }),
    input:  (provided: any, state: any) => ({
        ...provided,
        height: 24,
        marginTop: -6
      })
  }

  useEffect(() => {
    if (!hotwashStatus.currentSelection) { return; }
    const { currentSelection } = hotwashStatus;
    if (!currentSelection) {
      return;
    }
    const currentTurn = (
      (showHotwashNodeTimeline === 'show')
        ? currentSelection.nodeTurn
        : currentSelection.turn
      ).toString();
    setSelectedOption({ label: currentTurn, value: currentTurn });
  }, [showHotwashNodeTimeline, hotwashStatus.currentSelection]) // eslint-disable-line react-hooks/exhaustive-deps

  const updateHotwashStatus = useCallback(async (gameId: string | null) => {
      let hotwashStatusResp = await dispatch(getHotwashStatus(gameId))
      setHotwashStatus(hotwashStatusResp.payload)
      if (user === hotwashStatusResp.payload.hostId) {
        setIsHost(true)
      }
  }, [dispatch, user])

  useEffect(() => {
    async function asyncCall(currGame: IGameStatus) {
      let scenarioId: string = '';
      
      scenarioId = currGame.scenarioId
      let injects: any = await dispatch(fetchHotwashInjects(scenarioId))
      let finishedInjects: any = JSON.parse(JSON.stringify(currGame.finishedInjects));

      for (let j = 0; j<finishedInjects.length; j++) {
        for (let k = 0; k<injects.payload.injects.length; k++) {
          if (finishedInjects[j].injectId === injects.payload.injects[k].injectId) {
            finishedInjects[j].nodes = injects.payload.injects[k].inject.nodes
            finishedInjects[j].turnLength = injects.payload.injects[k].inject.turnLength
            finishedInjects[j].turnOrder = injects.payload.injects[k].turnOrder
          }
        }
      }

      setCurrentGame(currGame)
      setHotwashInjects(finishedInjects)

      let scenarios: any = await dispatch(getAllScenarios())
      
      setSelectedScenario(scenarios.payload.scenarios.filter((scen: IScenario, i: number) => currGame.scenarioId === scen.id)[0])
    }
    
    const getGame = async () => {
      let games: any = await dispatch(fetchGames())
      for (let i = 0; i<games.payload.length; i++) {
        if (games.payload[i].gameId === gameId) {
          if (user === games.payload[i].host) {
            setIsHost(true)
          }
          if (games.payload[i].hotwashSelection === 1) {
            asyncCall(games.payload[i]);
            updateHotwashStatus(gameId);
            setTimeout(() => {
              updateHotwashStatus(gameId)
            }, 10000)
          } else {
            openModal();
          }
        }
      }
    }

    if (gameId !== null) {
      getGame();
    }
  }, [dispatch, gameId, updateHotwashStatus, user]);

  const customStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0',
      border: 'none',
      width: '480px',
      transform: 'translate(-50%, -50%)',
    }
  };

  const customStyles1 = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '20px',
      border: 'none',
      width: '586px',
      minHeight: '300px',
      transform: 'translate(-50%, -50%)',
    }
  };

  const clickAnywhere = (ev: MouseEvent) => {
    if (ev.target instanceof HTMLElement) {
      if (!ev.target.classList.contains('inject') && !ev.target.classList.contains('action-btn')) {
        setHotwashInjects(hotwashInjects.map(inject => {
          return { ...inject, isSelected: '' };
        }));
      }
    }
  }

  const openModal = () => {
    setIsOpen(true);
  }

  const closeModal = () => {
    setIsOpen(false);
  }

  const closeAARCModal = () => {
    setModalAARCIsOpen(false);
  }

  const showHotwashTimeline = async () => {
    if (isHost) {
      let newHostSelection: any = {};
      newHostSelection.hotwashId = hotwashStatus.gameId;
      newHostSelection.hostSelection = new HostSelection();
      
      newHostSelection.hostSelection.page = '';
      newHostSelection.hostSelection.turn = 1;
      newHostSelection.hostSelection.inject = -1;
      newHostSelection.hostSelection.node = '';
      newHostSelection.hostSelection.nodeTab = '';
      newHostSelection.hostSelection.nodePlayerID = '';
      await dispatch(updateHotwashSelection(newHostSelection))
    }
    updateHotwashStatus(hotwashStatus.gameId)
    setShowHotwashTurnTimeline('show');
    setShowHotwashNodeTimeline('hide');
  }

  const onChangeAARC = (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
    const target = ev.currentTarget as HTMLTextAreaElement;

    if (target) {
      setNewAARCValue(target.value)
    }
  }

  const saveAARC = async (ev: MouseEvent) => {

  }

  const startHotwashBtn = async (ev: MouseEvent) => {
    ev.stopPropagation();

    const target = ev.currentTarget as HTMLButtonElement;

    if (target) {
        let startHotwashResponse: any = await dispatch(startHotwash(gameId))
        let newHostSelection: any = {};
        newHostSelection.hotwashId = startHotwashResponse.payload.gameId;
        newHostSelection.hostSelection = new HostSelection();
        
        newHostSelection.hostSelection.page = '';
        newHostSelection.hostSelection.turn = 1;
        newHostSelection.hostSelection.inject = -1;
        newHostSelection.hostSelection.node = '';
        newHostSelection.hostSelection.nodeTab = '';
        newHostSelection.hostSelection.nodePlayerID = '';
        await dispatch(updateHotwashSelection(newHostSelection))
        updateHotwashStatus(startHotwashResponse.payload.gameId)

        let currGame: IGameStatus = new GameStatus();
        let games: any = await dispatch(fetchGames())
        for (let i = 0; i<games.payload.length; i++) {
          if (games.payload[i].gameId === gameId) {
            currGame = games.payload[i];
          }
        }

        let scenarioId: string = '';
      
        scenarioId = currGame.scenarioId
        let injects: any = await dispatch(fetchHotwashInjects(scenarioId))
        let finishedInjects: any = JSON.parse(JSON.stringify(currGame.finishedInjects));
  
        for (let j = 0; j<finishedInjects.length; j++) {
          for (let k = 0; k<injects.payload.injects.length; k++) {
            if (finishedInjects[j].injectId === injects.payload.injects[k].injectId) {
              finishedInjects[j].nodes = injects.payload.injects[k].inject.nodes
              finishedInjects[j].turnLength = injects.payload.injects[k].inject.turnLength
              finishedInjects[j].turnOrder = injects.payload.injects[k].turnOrder
            }
          }
        }
  
        setCurrentGame(currGame)
        setHotwashInjects(finishedInjects)
  
        let scenarios: any = await dispatch(fetchScenarios())
        setSelectedScenario(scenarios.payload.myScenarios.filter((scen: IScenario, i: number) => currGame.scenarioId === scen.id)[0])

        closeModal();
    }
  }

  const getZoomClass = (i: number) => {
    switch(i) {
      case 1:
        return 'zoom-1'
      case 2:
        return 'zoom-2'
      case 3:
        //setShowHotwashTurnTimeline('hide');
        //setShowHotwashNodeTimeline('show');
        return 'zoom-3'
      case 4:
        //setShowHotwashTurnTimeline('show');
        //setShowHotwashNodeTimeline('hide');
        return 'zoom-4'
      case 5:
        return 'zoom-5' 
      default:
        break;
    }
  }

  const zoomIn = async (ev: MouseEvent) => {
    const target = ev.currentTarget as HTMLElement;
    
    if (target) {
      if (zoomLevel === 2) {
        return;
      }

      let selectedInject: any = document.querySelector('.hotwash-inject.selected')

      if (zoomLevel === 4 && selectedInject !== null) {
        setShowHotwashTurnTimeline('hide');
        setShowHotwashNodeTimeline('show');
        
        hotwashInjects.forEach((inject: IInjectInfo) => {
            if (inject.isSelected === 'selected') {
              setInjectItem(inject);
            }
        });
      }

      if (zoomLevel === 4 && selectedInject === null) {
        return;
      }
      
      if (zoomLevel < 6 && zoomLevel > 2) {
        setZoomLevel(--zoomLevel)
      }
    }
  }

  const zoomOut = async (ev: MouseEvent) => {
    const target = ev.currentTarget as HTMLElement;
    if (target) {
      if (zoomLevel === 5) {
        return;
      }

      if (zoomLevel === 3) {
        showHotwashTimeline()
      }

      if (zoomLevel > 0) {
        setZoomLevel(++zoomLevel)
      }
    }
  }

  const zoomReset = async (ev: MouseEvent) => {
    setZoomLevel(4)
    showHotwashTimeline()
  }

    const updateTurn = async (action: TurnUpdateType, amount: number): Promise<void> => {
      if (!isHost) { return; }

      const { currentSelection } = hotwashStatus;
      const isInjectView = showHotwashNodeTimeline === 'show';
      const currentTurn = (isInjectView) ? currentSelection.nodeTurn : currentSelection.turn;
      const nextTurn = action === TurnUpdateType.INCREMENT ? currentTurn + amount : amount;
      if (0 < nextTurn && nextTurn <= selectedScenario.gameTimeInterval) {
        const newHostSelection = new NewHostSelection(hotwashStatus.gameId);
        const { hostSelection } = newHostSelection;
        hostSelection.inject = currentSelection.inject;

        if (isInjectView) {
          hostSelection.turn = currentSelection.turn;
          hostSelection.nodeTurn = nextTurn;
        }
        else {
          hostSelection.turn = nextTurn;
          hostSelection.nodeTurn = currentSelection.nodeTurn;
        }
        await dispatch(updateHotwashSelection(newHostSelection))
        updateHotwashStatus(hotwashStatus.gameId)
      }
    }

    const clickTurnLeft = (ev: React.MouseEvent<HTMLElement>) => {
      updateTurn(TurnUpdateType.INCREMENT, -1);
    }

    const clickTurnRight = async (ev: React.MouseEvent<HTMLElement>) => {
      updateTurn(TurnUpdateType.INCREMENT, 1);
    }

    const changeTurnInput = async (selectedOption: ISelectedOption | null, actionMeta: ActionMeta<ISelectedOption>) => {
        if (!isHost || !selectedOption) { return };
        setSelectedOption(selectedOption);
        updateTurn(TurnUpdateType.SET, parseInt(selectedOption.value, 10));
      };
    
      const options: ISelectedOption[] = [];
     
      for (let i = 0; i<selectedScenario.gameTimeInterval; i++) {
          options.push({ value: (i+1).toString(), label: (i+1).toString() })
      }
    

  return (
    <div className={`txp-scenario-creator ${getZoomClass(zoomLevel)}`} onClick={clickAnywhere}>
        <HotwashHeader selectedScenario={selectedScenario} injectItem={injectItem} setSelectedScenario={setSelectedScenario} currentGame={currentGame} isHost={isHost} hotwashStatus={hotwashStatus} updateHotwashStatus={updateHotwashStatus} zoomLevel={zoomLevel} intervalHandler={intervalHandler} gameId={gameId} onNavTimeline={showHotwashTimeline}/>
      <div className="txp-sc-main">
        <div className={`txp-content`}>
          <div className="txp-sc-sidemenu">
            <button className="sidemenu-icon1" onClick={showHotwashTimeline}>
              <img className="sidemenu-icon1-svg" src="img/sidemenu-icon1.svg" alt="timeline" />
            </button>
          </div>

          <div className="txp-sc-actions">
          <div className="hotwash-header-turn">
                  {hotwashStatus.hostId === user &&
                  <div className="hotwash-header-turn-btn" onClick={clickTurnLeft} >
                      <img src="img/turn-left.svg" alt="left"/>
                  </div>
                  }
                  <div className="hotwash-header-turn-label">Turn &nbsp;
                    {hotwashStatus.hostId === user
                    ? <Select
                      value={selectedOption}
                      components={{ DropdownIndicator: CustomDropdownIndicator }}
                      onChange={changeTurnInput}
                      options={options}
                      styles={dropdownStyles}
                      isDisabled={hotwashStatus.hostId !== user}
                    />
                    : <span>{(selectedOption?.value || '1')} </span>
                    }
                    of {selectedScenario.gameTimeInterval}</div>
                  {hotwashStatus.hostId === user &&
                  <div className="hotwash-header-turn-btn" onClick={clickTurnRight}>
                      <img src="img/turn-right.svg" alt="right"/>
                  </div>
                  }
              </div>
            <div className="zoom-controls">
                <button className="zoom-in zoom-control" onClick={zoomIn}>
                  <img src="img/zoom-in.svg" alt="zoom" />
                </button>
                <button className="zoom-out zoom-control" onClick={zoomOut}>
                  <img src="img/zoom-out.svg" alt="zoom" />
                </button>
                <button className="zoom-reset zoom-control" onClick={zoomReset}>
                  <img src="img/zoom-reset.svg" alt="zoom" />
                </button>
            </div>
          </div>

          <HotwashTurnTimeline hotwashInjects={hotwashInjects} setInjectItem={setInjectItem} injectItem={injectItem} setHotwashInjects={setHotwashInjects} gameTimeInterval={selectedScenario.gameTimeInterval} showHotwashTurnTimeline={showHotwashTurnTimeline} setShowHotwashTurnTimeline={setShowHotwashTurnTimeline} setShowHotwashNodeTimeline={setShowHotwashNodeTimeline} hotwashStatus={hotwashStatus} updateHotwashStatus={updateHotwashStatus} currentGame={currentGame} isHost={isHost} zoomLevel={zoomLevel} setZoomLevel={setZoomLevel} lastUserClick={lastUserClick} setLastUserClick={setLastUserClick} selectedScenario={selectedScenario} /> 

          <HotwashNodeTimeline hotwashInjects={hotwashInjects} showHotwashNodeTimeline={showHotwashNodeTimeline} gameTimeInterval={selectedScenario.gameTimeInterval} setInjectItem={setInjectItem} injectItem={injectItem} currentGame={currentGame} hotwashStatus={hotwashStatus} updateHotwashStatus={updateHotwashStatus} isHost={isHost} currentTurn={1} zoomLevel={zoomLevel} />

      </div>
      </div>
      <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          shouldCloseOnOverlayClick={false}
          contentLabel="Game Over Modal"
      >
          <div className="enter-password">Hotwash has not been started.  Click below to start the Hotwash.</div>

          <button onClick={startHotwashBtn} className="delete-confirm-btn">Start Hotwash</button><button onClick={closeModal} className="delete-cancel-btn">Cancel</button>
      </Modal>
      <Modal
          isOpen={modalAARCIsOpen}
          onRequestClose={closeAARCModal}
          style={customStyles1}
          shouldCloseOnOverlayClick={false}
          contentLabel="AARC Modal"
      >
          <div className="aarc-modal-title">AARCs</div>
          <div className="aarc-modal-content"></div>
          <div className="aarc-modal-new-title">Add new AARC</div>
          <textarea className="aarc-modal-content" value={newAARCValue} onChange={onChangeAARC}></textarea>
          <button className="save-aarc-button" onClick={saveAARC}>Save AARC</button>
      </Modal>
    </div>
  );
}

export default HotwashApp;
